export class PerimetreFilters {
	
	codeParc: string = "";
	selectedAgenceIds!: number[];

	constructor() { }

}